import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import getUserLocale from 'get-user-locale';
import { Observable } from 'rxjs';

import { LanguageService } from '../../services/language';
import { AuthService } from '../auth';

@Injectable({
	providedIn: 'root'
})
export class LanguageGuardService implements CanActivate {
	constructor(public languageService: LanguageService, private authService: AuthService) {}

	public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		const locale = this.authService?.accountUser?.locale ? this.authService.accountUser.locale : getUserLocale();

		return new Observable<boolean>((observer) => {
			observer.next(this.languageService.validateAppLanguage(locale));
			observer.complete();
		});
	}
}
